//** Lead Api

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// Axios Imports
import { toast } from 'react-toastify';
import axios from '@src/service/axios';
// import themeConfig from '../../../configs/themeConfig';
import { setLoading } from '../../../../@core/components/skelton/store';
export const get11Za = createAsyncThunk('callSlice/get11Za', async () => {
    try {
        let response = await axios.get('/whatsapp-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getMyOperator = createAsyncThunk('callSlice/get-call-configuration', async (_, { dispatch, rejectWithValue }) => {
    try {
        dispatch(setLoading(true));
        let response = await axios.get('/get-call-configuration', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        dispatch(setLoading(false));
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        console.log('err', err);
        dispatch(setLoading(false));
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const create11za = createAsyncThunk('callSlice/create11za', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/oneoneza-configurations', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Lead added successfully.');
        dispatch(get11Za());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createMyOperator = createAsyncThunk('oneOneZaSliMyOperator', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/myoperator-configurations', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator  added successfully.');
        dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const update11za = createAsyncThunk('callSlice/update11za', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/oneoneza-configurations/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Lead updated successfully.');
        await dispatch(get11Za());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateMyOperator = createAsyncThunk('callSlice/updateMyOperator', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/call-configuration', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator updated successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateMyOperatorStatus = createAsyncThunk('callSlice/updateMyOperatorStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/call-configuration/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'My Operator Status Changed successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (error) {
        toast.error(error?.response?.data?.message || 'Something went wrong!');
        console.log('err during update My Operator status ', error?.response?.data);
        return Promise.reject(error?.response?.data);
    }
});

export const delete11za = createAsyncThunk('callSlice/delete11za', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/oneoneza-configurations/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Lead deleted successfully.');
        await dispatch(get11Za());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deleteMyOperator = createAsyncThunk('callSlice/deleteMyOperator', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/call-configuration/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'MyOperator deleted successfully.');
        await dispatch(getMyOperator());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const callSlice = createSlice({
    name: 'callSlice',
    initialState: {
        data: [],
        myOperator: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(get11Za.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getMyOperator.fulfilled, (state, action) => {
            state.myOperator = action.payload;
            return;
        });
    }
});

export default callSlice.reducer;
